export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/hand_drawn.3ef28f4.svg";